import React from 'react';

// Full-screen modal shown until the DB content (texts) and its key images are ready.
const LoadingOverlay: React.FC = () => (
  <div className="loading-overlay" role="status" aria-live="polite">
    <div className="loading-overlay-box">
      <div className="loading-overlay-spinner" aria-hidden="true"></div>
      <p>資料載入中…</p>
    </div>
  </div>
);

export default LoadingOverlay;
